"use client";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import Next from "../../../public/homePage/next.svg";
import Prev from "../../../public/homePage/prev.svg";
import Slider from "react-slick";
import Image from "next/image";
import { useState } from "react";

type ProductDataType = {
  header: string;
  description: string[] | [];
  image: any;
  classes: string;
};

type PropsType = {
  productData: ProductDataType[];
  newClass?: any;
  beforeAfterClass?: any;
  pageName?: any;
};

const NewSlider = (props: PropsType) => {
  const { productData, newClass, beforeAfterClass } = props;
  const [currentSlide, _] = useState(0);
  const [clickedArrow, setClickedArrow] = useState("");

  const SampleNextArrow = (props: any) => {
    const { className, onClick, clickedArrow } = props;
    // console.log("next");
    return (
      <Next
        className={
          className +
          ` productivity-next ${
            clickedArrow === "right" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("right");
          onClick();
        }}
        disabled={currentSlide === productData?.length - 1}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;
    // console.log("prev");
    return (
      <Prev
        className={
          className +
          ` productivity-prev ${
            clickedArrow === "left" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("left");

          onClick();
        }}
        disabled={currentSlide === 0}
      />
    );
  };

  let settings = {
    dots: true,
    infinite: true,
    speed: 250,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    nextArrow: <SampleNextArrow clickedArrow={clickedArrow} />,
    prevArrow: <SamplePrevArrow clickedArrow={clickedArrow} />,
  };

  return (
    <div className={beforeAfterClass}>
      <Slider {...settings}>
        {productData.map((data, index) => {
          const SvgImage = data.image;
          return (
            <div className={`slider-inner-con  `} key={index}>
              <div className="container-fluid overflow-hidden slider-margin res-exprience">
                <div className="row">
                  <div
                    className={
                      "col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 sec-paragraph d-flex flex-column justify-content-center carousel-paragraph"
                    }>
                    {data?.header && (
                      <div className="header-container heading-sec res-head">
                        <h2>{data?.header}</h2>
                        <div className="horizontal-row"></div>
                      </div>
                    )}
                    {data.description.map((desc, index) => {
                      return <p key={index}>{desc}</p>;
                    })}
                  </div>
                  <div
                    className={
                      "col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 img-col design-ins"
                    }>
                    <div className={`slider-img ${data.classes} ${newClass}`}>
                      <Image
                        src={SvgImage}
                        alt="slider image"
                        fill
                        className="responsive-image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default NewSlider;
